export const getPageId = (path: string) => {
    const matches = (pattern: string) => RegExp(pattern).test(path);

    switch (true) {
        case matches('/login'):
            return 'login';
        case matches('/checkout/register'):
            return 'checkout';
        case matches('/onboarding/category(?=.*existingUser=true)'):
            return 'onboarding_category_existing';
        case matches('/onboarding/subcategory(?=.*existingUser=true)'):
            return 'onboarding_subcategory_existing';
        case matches('/onboarding/goal(?=.*existingUser=true)'):
            return 'onboarding_goal_existing';
        case matches('/onboarding/experience(?=.*existingUser=true)'):
            return 'onboarding_experience_existing';
        case matches('/onboarding/trainer(?=.*existingUser=true)'):
            return 'onboarding_trainer_existing';
        case matches('/onboarding/category'):
            return 'onboarding_category';
        case matches('/onboarding/subcategory'):
            return 'onboarding_subcategory';
        case matches('/onboarding/goal'):
            return 'onboarding_goal';
        case matches('/onboarding/experience'):
            return 'onboarding_experience';
        case matches('/onboarding/trainer'):
            return 'onboarding_trainer';
        case matches('/onboarding/user-type'):
            return 'onboarding_user_type';
        case matches('/onboarding/survey'):
            return 'onboarding_survey';
        case matches('/onboarding/selection/[^/]+/[^/]+/[^/]+(?=.*)?'):
            return 'onboarding_lesson_welcome';
        case matches('/onboarding/selection'):
            return 'onboarding_personalized_selection';
        case matches('/preferences/settings'):
            return 'preference_settings';
        case matches('/preferences/categories'):
            return 'preference_categories';
        case matches('/preferences/subcategories'):
            return 'preference_subcategories';
        case matches('/preferences/goals'):
            return 'preference_goals';
        case matches('/preferences/experience'):
            return 'preference_experience';
        case matches('/preferences/trainers'):
            return 'preference_trainers';
        case matches('/configure/trainers'):
            return 'favorite_trainers';
        case matches('/courses/[^/]+/[^/]+/[^/]+'):
            return 'lesson_viewer';
        case matches('/courses/[^/]+/navigator'):
            return 'course_navigator';
        case matches('/courses/[^/]+/module-complete'):
            return 'module_completion';
        case matches('/courses/[^/]+/course-complete'):
            return 'course_completion';
        case matches('/courses/[^/]+/recommendations'):
            return 'course_completion_recommendations';
        case matches('/courses/[^/]+/[^/]+'):
            return 'course_detail_video';
        case matches('/courses/[^/]+'):
            return 'course_detail';
        case matches('/courses(?=.*onlyFavorites=true)'):
            return 'course_catalog_favorites';
        case matches('/courses'):
            return 'course_catalog';
        case matches('/shorts/[^/]+'):
            return 'short_viewer';
        case matches('/shorts'):
            return 'shorts_feed';
        case matches('/live-events/[^/]+'):
            return 'live_event_detail';
        case matches('/live-events'):
            return 'live_events';
        case matches('/settings/payment-history'):
            return 'payment_history';
        case matches('/settings'):
            return 'settings';
        case matches('/online-vet'):
            return 'online_vet';
        case matches('/[a-z]{2}$'):
        case matches('/[a-z]{2}/$'):
            return 'dashboard';
        default:
            return null;
    }
};
